export default __webpack_public_path__ + "static/media/EditIcon.eddfe08d.svg";